import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { CoreModule } from "@tylertech/core-module";

import { DataLoadService, DataSearchService } from "./services";

@NgModule({
    imports: [
        CoreModule
    ],
    providers: [
        DataLoadService,
        DataSearchService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DataLoadModule { }
